import { jsx as _jsx } from "react/jsx-runtime";
import { lazyNamed } from './lazy';
import { ViewSkeleton, DetailsPanelSkeleton } from '@widget/loaders';
import { DashboardSkeleton } from '@core/dashboard/DashboardSkeleton';
const FALLBACKS = {
    view: _jsx(ViewSkeleton, {}),
    list: _jsx(ViewSkeleton, {}),
    dashboard: _jsx(DashboardSkeleton, {}),
    detailspanel: _jsx(DetailsPanelSkeleton, {}),
    none: null,
};
/**
 * Lazy-load a named export of a module, wrapped in Suspense with a preset (or
 * custom) skeleton fallback. Replaces the hand-rolled `React.lazy` + `<Suspense>`
 * block each app copy-pastes per view.
 *
 * @example
 *   const LayoutView = lazyView(() => import('./views/layout/LayoutView'), 'LayoutView', 'dashboard');
 *   // default export:
 *   const Uploader = lazyView(() => import('./forms/Uploader'), 'default', 'none');
 *
 * The `load` closure is authored in the app bundle, so webpack code-splits it out
 * of the app; this helper and its skeletons live in the framework's main bundle.
 */
export function lazyView(load, exportName, fallback = 'view') {
    var _a;
    const fb = typeof fallback === 'string'
        ? ((_a = FALLBACKS[fallback]) !== null && _a !== void 0 ? _a : FALLBACKS.view)
        : fallback;
    return lazyNamed(load, exportName, fb);
}
